module.exports = __webpack_public_path__ + "img/apple-touch-icon.cc93c834.png";